// Actions related to API calls for the device
import { batch } from "react-redux";
import axios from "axios";
import { serverURL } from "../../constants/constants";

// Import necessary calls from other files
import {
  errorResponse,
  fetchSetDz,
  toggleDiagnosticsDialog,
} from "../../actions";
import { defaultPercentSliceWidth, csiTypes } from "../../constants/constants";
import { alineFixture } from "../../constants/Fixtures/sampleFixture";
export function fetchConnectDevice(simulate = false) {
  return function (dispatch, getState) {
    let state = getState();
    let sws_range = null;
    if (Object.keys(state.protocol).includes("sws_range")) {
      sws_range = [state.protocol.sws_range[0], state.protocol.sws_range[1]];
    }
    let req = {
      simulate: simulate,
      study_id: state.studyInfo.id,
      participant_id: state.studyInfo.participantId,
      protocol_id: state.studyInfo.protocolId,
      sws_range: sws_range,
      encryption: state.studyInfo.encryption,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
    };
    console.log("POST request made for /init_device with", req);
    dispatch(requestConnectDevice(simulate));
    dispatch(deviceConnected());
    // return axios.post(serverURL + "/init_device", req).then((response) => {});
  };
}

export const REQUEST_CONNECT_DEVICE = "REQUEST_CONNECT_DEVICE";
export function requestConnectDevice(simulate) {
  return {
    type: REQUEST_CONNECT_DEVICE,
    simulate: simulate,
  };
}

// SSE Event
export function deviceConnected() {
  return (dispatch, getState) => {
    let state = getState();
    // if (data.error === true) {
    //   // Error in connecting to device
    //   dispatch(errorResponse(data.message));
    //   dispatch(
    //     receiveConnectDevice(data.error, data.serial_number, data.simulate)
    //   );
    //   if (state.utility.dialog.diagnosticsDialog) {
    //     dispatch(toggleDiagnosticsDialog());
    //   }
    // } else if (data.error === false) {
    const locationId = state.locations.selectedLocationId;
    const acqType = state.locations.currentAcqType;
    dispatch(receiveConnectDevice(false, "Simulated Device", true));

    // Set the current location ID, acq type, and param id on the device
    dispatch(fetchSetLocation(locationId, acqType));
    let locationRoi = getLocationZandDzValues(state);
    dispatch(fetchSetDz(locationRoi.dz, locationRoi.z));
    // }
  };
}

export const RECEIVE_CONNECT_DEVICE = "RECEIVE_CONNECT_DEVICE";
export function receiveConnectDevice(error, serialNumber, simulate) {
  return {
    type: RECEIVE_CONNECT_DEVICE,
    error: error,
    serialNumber: serialNumber,
    simulate: simulate,
  };
}

export function getLocationZandDzValues(state) {
  // Extract dz and z values for the selected location based on the roi references for the location
  let location = state.locations.byId[state.locations.selectedLocationId];
  let location_dz = null;
  let location_z = null;

  if (location.roiReference.locationWide.id !== null) {
    let roiSample = state.samples.byId[location.roiReference.locationWide.id];
    if (roiSample.type === "BMODE") {
      location_dz = (roiSample.thickness * defaultPercentSliceWidth) / 100;
      location_z = roiSample.zValue;
    } else if (csiTypes.includes(roiSample.type)) {
      location_dz = roiSample.roiDz;
      location_z = roiSample.zValue;
    }
  } else if (location.roiReference.default !== null) {
    let roiSample = state.samples.byId[location.roiReference.default];
    location_dz = (roiSample.thickness * defaultPercentSliceWidth) / 100;
    location_z = roiSample.zValue;
  }

  return { dz: location_dz, z: location_z };
}

export function fetchSetLocation(locationId, acqType, force = false) {
  return function (dispatch, getState) {
    let state = getState();
    const lastSetLocation = state.locations.lastSetLocation;
    // if (
    //   lastSetLocation.location !== locationId ||
    //   lastSetLocation.acqType !== acqType ||
    //   force
    // ) {
    //Dont make get request if lastSetlocation is the requested location
    dispatch(requestSetLocation());
    let paramId = state.protocol.locations[locationId].parameters_id;
    console.log(
      "GET request made for /set_current_location with location Id:",
      locationId,
      "acqType: ",
      acqType,
      " and param ID :",
      paramId
    );
    // return axios
    //   .get(
    //     serverURL +
    //       "/set_current_location/" +
    //       acqType +
    //       "/" +
    //       paramId +
    //       "/" +
    //       locationId
    //   )
    //   .then(
    //     (response) =>
    dispatch(receiveSetLocation({}, locationId, acqType));
    //       (error) => dispatch(errorResponse(error))
    //     );
    // }
  };
}

export const REQUEST_SET_LOCATION = "REQUEST_SET_LOCATION";
export function requestSetLocation() {
  return {
    type: REQUEST_SET_LOCATION,
  };
}

export const RECEIVE_SET_LOCATION = "RECEIVE_SET_LOCATION";
export function receiveSetLocation(response, locationId, acqType) {
  return {
    type: RECEIVE_SET_LOCATION,
    response,
    locationId: locationId,
    acqType: acqType,
  };
}

export function requestHealth() {
  return function (dispatch) {
    // Reset device heatlh
    dispatch(resetHealth());
    console.log("GET request made for /check_device_health");
    dispatch(
      receiveHealth({
        health: true,
        cap_height: 8,
        message: "Simulate device does not run diagnostics",
      })
    );
    // return axios.get(serverURL + "/check_device_health").then(
    //   (response) => {}, //console.log("health requested"),
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const RECEIVE_HEALTH = "RECEIVE_HEALTH";
export function receiveHealth(response) {
  return {
    type: RECEIVE_HEALTH,
    health: response.health,
    message: response.message,
    capHeight: response.cap_height,
    sws: response.sws,
  };
}

export const RESET_HEALTH = "RESET_HEALTH";
export function resetHealth() {
  return {
    type: RESET_HEALTH,
  };
}

export function fetchPing() {
  return function (dispatch) {
    console.log("GET request made for /get_calibration_data");
    dispatch(receivePing(alineFixture));
    // return axios.get(serverURL + "/get_calibration_data").then(
    //   (response) => {},
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const RECEIVE_PING = "RECEIVE_PING";
export function receivePing(response) {
  return {
    type: RECEIVE_PING,
    response: response,
  };
}

export function fetchCloseDevice(prompt) {
  return function (dispatch) {
    console.log("GET request made for /close_device");
    // return axios.get(serverURL + "/close_device").then(
    //   (response) => {
    //     batch(() => {
    //       dispatch(receiveCloseDevice(response.data));
    //     });
    //   },
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

export const RECEIVE_CLOSE_DEVICE = "RECEIVE_CLOSE_DEVICE";
export function receiveCloseDevice(response) {
  return {
    type: RECEIVE_CLOSE_DEVICE,
    response,
  };
}
